import { InjectionToken } from '@angular/core';
import { BrandConfig } from './brand-config.interface';

export const BRAND_CONFIG = new InjectionToken<BrandConfig>('BrandConfig');
